define('components/can-toggle',['jquery', 'core/can'], function($, can) {
	
	can.view.attr('can-toggle', function(el, attrData) {
		
		el = $(el);
		
		el.on('inserted', function() {
			el.find(':checked').closest('.btn').addClass('active');
		});
		
/*
		el.find('input').change(function(e) {
			window.setTimeout(function() {
				$(e.target).parent().toggleClass('active', e.target.checked);
			}, 0);
		});
*/
	});

});
